import {Box, Grid, Theme} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, {FC, useCallback, useEffect, useRef} from 'react';
import {useFormContext} from 'react-hook-form';
import {useSelector} from 'react-redux';
import product4IllustrationImg from '../../../../assets/products/product-4/product4Illustration.png';
import {localized, localizedInterpolation} from '../../../../i18n/i18n';
import {AppState} from '../../../../state/store';
import {
  getValueLengthWithUnitByCulture,
  getValueRangeWithUnitByCulture,
} from '../../../../utilities/helpers/culture-settings-helper';
import {getConfigurationParamByName} from '../../../../utilities/helpers/product-helper';
import {BinaryButtonInput} from '../../../components/custom-components/configuration/dynamic-components/binary-button-input';
import {ImageRow} from '../../../components/custom-components/configuration/dynamic-components/image-row';
import {RecommondetionTextRow} from '../../../components/custom-components/configuration/dynamic-components/recommondetion-text-row';
import {IntroductionRow} from '../../../components/custom-components/configuration/step-2/introduction-row';
import {SargSelector} from '../../../components/custom-components/configuration/step-2/sarg-selector';
import {frameDepth, frameLength, hasFascia, numberOfTableFrameFittings} from '../configuration-constants';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {
      width: '686px',
    },
    gridItem: {
      height: '120px',
    },
    gridITextItem: {
      height: '80px',
    },
  }),
);

export interface PropsFromParent {}

export const Product4Step2: FC<PropsFromParent> = React.memo(({...props}) => {
  const classes = useStyles();
  const selectedProduct = useSelector((store: AppState) => store.projectReducer.selectedProduct);
  const {unitsId} = useSelector((store: AppState) => store.urlSettingsReducer.cultureUrlParameters);
  const {setValue, unregister} = useFormContext();
  const myRef = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    if (myRef && myRef.current) {
      myRef.current.scrollIntoView({block: 'end'});
    }
  }, []);

  const useCaseBtnCallback = useCallback(
    (value: boolean) => {
      if (value) {
        unregister(numberOfTableFrameFittings);
        setValue(frameLength, null);
        setValue(frameDepth, null);
        setValue(numberOfTableFrameFittings, null);
      } else {
        setValue(frameLength, undefined);
        setValue(frameDepth, undefined);
        setValue(numberOfTableFrameFittings, undefined);
      }
    },
    [setValue, unregister],
  );

  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center" sx={{flexGrow: 1}}>
        <Grid container spacing={2} className={classes.grid}>
          <Grid ref={myRef} container spacing={3}>
            <IntroductionRow minHeight={'100'} />
          </Grid>

          <Grid container spacing={3}>
            <BinaryButtonInput
              formName={hasFascia}
              value1={'true'}
              value2={'false'}
              btnLabel1={localized('Yes')}
              btnLabel2={localized('No')}
              defaultValue={getConfigurationParamByName(selectedProduct, hasFascia)}
              label={localized('HasTableFrame')}
              buttonPressedCallback={useCaseBtnCallback}
            />
          </Grid>

          <Grid container spacing={3}>
            <ImageRow imgString={product4IllustrationImg} />
          </Grid>

          <Grid container spacing={3}>
            <RecommondetionTextRow
              recommondetionString={localizedInterpolation('CasketRecommendation', {
                value1: getValueLengthWithUnitByCulture(unitsId, '100'),
                value2: getValueRangeWithUnitByCulture(unitsId, '16', '30'),
              })}
            />
          </Grid>

          <SargSelector productWithMotor={false} />
        </Grid>
      </Box>
    </>
  );
});
